module.exports = {
  title: 'Sambla Kundportal',
  metaDescription: 'Logga in för att se status på din låneansökan.',
  jsInfo: 'Du behöver aktivera JavaScript för att se denna sida. Se till att du använder en modern webbläsare och aktivera JavaScript i den.',
  unSupportedBrowser: 'Vi stödjer tyvärr inte din webbläsare. Vissa funktioner på sidan kommer inte att fungera. Se till att du använder en modern webbläsare.',
  titleForm: 'Sambla Form',
};
